import { render, staticRenderFns } from "./FCCCountry.vue?vue&type=template&id=afaf765a"
import script from "./FCCCountry.vue?vue&type=script&lang=js"
export * from "./FCCCountry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports